/**
 * Tiny bus between the tour entry points (Today checklist link, navbar
 * user-chip menu, Settings Help card) and the TourProvider mounted in Layout.
 *
 * A manual request always runs — it overrides seen state AND the global
 * opt-out ("opt-out kills push, never pull", tour spec §5) — and navigates
 * to `path` first when the current route doesn't host the tour's anchors.
 */

import { create } from 'zustand';
import type { TourId } from './registry';

export interface TourRequest {
  id: TourId;
  /** Route to navigate to before starting; null = current route already hosts it. */
  path: string | null;
  /** Monotonic nonce so re-requesting the same tour re-fires the effect. */
  nonce: number;
}

interface TourStoreState {
  requested: TourRequest | null;
  /** Bumps whenever tour storage changes — lets the Settings card re-read state. */
  storageVersion: number;
  request: (id: TourId, path?: string | null) => void;
  clearRequest: () => void;
  bumpStorageVersion: () => void;
}

let nonce = 0;

export const useTourStore = create<TourStoreState>((set) => ({
  requested: null,
  storageVersion: 0,
  request: (id, path = null) => set({ requested: { id, path, nonce: ++nonce } }),
  clearRequest: () => set({ requested: null }),
  bumpStorageVersion: () => set((s) => ({ storageVersion: s.storageVersion + 1 })),
}));
